<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <didi_general_tab :location="location"></didi_general_tab>
        </template>

    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import didi_general_tab from "./tabs/didi_general_tab";



export default {
    name: "did_location_modal",
    components : {
        base_location_modal,
        didi_general_tab,
    },
    data () {
        return {
            tabs_add: [

            ]
        }
    },

    created() {
        EventBus.$on('after_save_location',this.afterSave);
    },

    methods: {
        afterSave(data) {
            console.log('after_save',data);
            if(data.hasOwnProperty("check")) {
                let is_ok = data.check?.ok ?? true;
                if(!is_ok) {
                    const need_redirect = data.check?.need_redirect ?? false;

                    if(need_redirect) {
                        this.oauth(data.uniq_id);
                    }
                }
            }
        },

        async oauth(loc_uni_id) {
            await api.post('/internal/oauth/didi/redirect',{
                'loc_id' : loc_uni_id
            }).then(({data}) => {
                if(data.status == "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("redirect")) {
                        window.open(resp.redirect);
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },



}
</script>

<style scoped>

</style>
